import React, {useEffect, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {Button, Input, Modal, Select} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {useDropdowns} from "../../../hooks/useDropdowns";
import {createTechnicianGroup} from "../../../Services/technicianGroup";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import NotifyCreateRecordModal from "../../../components/Modals/NotifyCreateRecordModal";

const TechnicianGroupManagementModal = ({
                                            showCreateTechnicianGroupModal,
                                            setShowCreateTechnicianGroupModal,
                                            retrieveTechnicianGroupListing,
                                            showNotifyCreateRecordModal,
                                            setShowNotifyCreateRecordModal
                                        }) => {
    const dispatch = useDispatch();
    const {control, handleSubmit} = useForm();
    const {state, getTechnicianDropdown, getRegionsDropDown} = useDropdowns();
    const [technicians, setTechnicians] = useState([])


    useEffect(() => {
        getRegionsDropDown();
        retrieveTechnicians();
    }, []);

    const retrieveTechnicians = () => {
        getTechnicianDropdown().then(res => {
            setTechnicians(res)
        });
    }

    const createNewTechnicianGroup = (data) => {
        dispatch(SET_IS_API_CALLED("Creating Technician Group"));
        createTechnicianGroup({...data})
            .then(response => {
                if(response?.status <400){
                    setShowNotifyCreateRecordModal(true);
                    retrieveTechnicianGroupListing();
                    setShowCreateTechnicianGroupModal(!showCreateTechnicianGroupModal);
                }
            })
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });
    }

    return (
        <>

            <Modal
                title={"Add New Technician Group"}
                open={showCreateTechnicianGroupModal}
                onOk={() => {
                }}
                onCancel={() => {
                    setShowCreateTechnicianGroupModal(!showCreateTechnicianGroupModal)
                }}
                footer={null}
                data-testid={"TechnicianGroupManagementModal"}
            >
                <form>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className={"font-semibold"} htmlFor={"technicianGroupName"}>Name</label>
                            <Controller
                                name={"name"}
                                control={control}
                                render={({field}) => (
                                    <Input
                                        onChange={field.onChange}
                                        value={field.value}
                                        placeholder={"John Doe"}
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <label className={"font-semibold"} htmlFor={"technicianGroupDesc"}>Description</label>
                            <Controller
                                name={"description"}
                                control={control}
                                render={({field}) => (
                                    <TextArea
                                        onChange={field.onChange}
                                        value={field.value}
                                        placeholder={"Enter Description..."}
                                    />
                                )}
                            /></div>

                        <div>
                            <label className={"font-semibold"} htmlFor={"technicianGroupRegion"}>Region</label>
                            <Controller
                                name={"region"}
                                control={control}
                                render={({field}) => (
                                    <Select
                                        style={{width: "100%"}}
                                        placeholder="Please Select A Region"
                                        onChange={field.onChange}
                                        label={"name"}
                                        value={field.value}
                                        optionFilterProp="name"
                                        allowClear
                                        options={state.regionsDropDown?.map((val) => {
                                            return {
                                                value: val?.name,
                                                label: val?.name,
                                            };
                                        })}
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <label className={"font-semibold"} htmlFor={"technicianGroupIsActive"}>Status</label>
                            <Controller
                                name={"isActive"}
                                control={control}
                                render={({field}) => (
                                    <Select
                                        style={{width: "100%"}}
                                        placeholder="Please Select A Status"
                                        onChange={field.onChange}
                                        label={"name"}
                                        value={field.value}
                                        options={
                                            [{label: "Active", value: true}, {label: "Inactive", value: false}]
                                        }
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <label className={"font-semibold"}
                                   htmlFor={"technicianGroupNewTechnicians"}>Technicians</label>
                            <Controller
                                name={"newTechnicianIds"}
                                control={control}
                                render={({field}) => (
                                    <Select
                                        mode="multiple"

                                        style={{width: "100%"}}
                                        placeholder="Please Select A Status"
                                        onChange={field.onChange}
                                        label={"name"}
                                        value={field.value}
                                        options={technicians?.map((val) => {
                                            return {
                                                value: val?.technicianId,
                                                label: val?.name,
                                            };
                                        }) ?? []

                                        }
                                    />
                                )}
                            />
                        </div>
                        {/* placeholders */}
                        <div></div>
                        <div></div>

                        <div className={"justify-self-end self-end flex gap-5"}>
                            <Button
                                type="button"
                                onClick={handleSubmit(createNewTechnicianGroup)}
                                className={"bg-dark-blue-100 text-white"}
                            >
                                Submit
                            </Button>
                            <Button
                                type="button"
                                onClick={() => {
                                    setShowCreateTechnicianGroupModal(!showCreateTechnicianGroupModal);
                                }}
                                className={"bg-dark-blue-100 text-white"}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </form>
            </Modal>
        </>
    );
};

export default TechnicianGroupManagementModal;